<template>
  <div class="text-center">
    <h1 class="text-4xl font-bold mb-4">404 - Page Not Found</h1>
    <p class="text-xl mb-8">The page you're looking for doesn't exist.</p>
    <router-link to="/" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Go to Dashboard</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>